﻿import { DateOnly } from "./utilities";
import * as _ from "lodash";

const DATE_TIME_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
const DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;

export function jsonParseReviver(_key: string, value: unknown) : unknown {
    
    if (typeof value === 'string') {
        if (DATE_TIME_REGEX.exec(value)) {
            const parsedDate = new Date(value);
            // Fall back to raw string value if parsed date is invalid...
            return (parsedDate instanceof Date && !isNaN(parsedDate.valueOf())) ?
                parsedDate :
                value;
        } else if (DATE_REGEX.exec(value)) {
            const parsedDate = new DateOnly(value);
            // Fall back to raw string value if parsed date is invalid...
            return (parsedDate instanceof DateOnly && !isNaN(parsedDate.valueOf())) ?
                parsedDate :
                value;
        }
    }

    return value;
}

export class BaseClient {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        this.jsonParseReviver = jsonParseReviver;
    }
}